import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../actions/timer';
import { connect } from 'react-redux';
import { updateDatetime, getWsRecords } from "../actions/app"
import Rangecalendar from './rangeCalendar.jsx';

class Thisweektime extends Component {
    shouldComponentUpdate(nextProps, nextState){
        if(nextProps.recordsDuration !== this.props.recordsDuration) return true;
        else return false;
    }

    updateDateRange = date => {
        date.startDate = new Date(date.startDate).toISOString().split('T')[0] + 'T00:00:00';
    
            if(date.endDate) { // if endDate exist
                date.endDate = new Date(date.endDate).toISOString().split('T')[0] + 'T23:59:59';
            }
            else{ // if no endDate exist
                date.endDate = date.startDate.split('T')[0] + 'T23:59:59';
            }
        updateDatetime(date);
    }

    render() {
        this.thisWeekTime = this.props.recordsDuration;
        if (this.thisWeekTime === "0:00:00") this.thisWeekTime = undefined;
        return(
            <div className="this-week-time">
                <div className="this-week-right">
                    <i>
                        { (this.thisWeekTime)?( 'ماه جاری : '):(null) }
                        { this.thisWeekTime }
                    </i>
                </div>
                <div className="this-week-left">
                    <button className="submit-datetime" onClick={getWsRecords} >اعمال</button>
                    <Rangecalendar initDate={{startDate: this.props.app.start_date, endDate: this.props.app.end_date}} onDatesChange={this.updateDateRange} />
                </div>
            </div>
        );
  }
}

Thisweektime.defaultProps = {
    recordsDuration : 0
}

function mapStateToProps(state) {
  return {
    timer: state.timer,
    app: state.app
  }
}

function mapDispachToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispachToProps)(Thisweektime);
// export default Thisweektime;
